<template>
  <div class="form-group">
    <div class="row no-gutters"
         v-if="label">
      <div class="col">
        <label class="form-label"
               :class="formLabelClass"
               :data-content="label">
          <span>{{ label }}</span>
          <span v-if="required"> *</span>
        </label>
      </div>
      <div class="col-auto"><slot name="label-right"/></div>
    </div>
    <div class="position-relative"
         v-if="editMode"
         :class="inputRowClass">
      <input :type="type && !showPass ? type : 'text'"
             class="form-control"
             ref="input"
             :placeholder="placeholder ? placeholder : label"
             :autocomplete="autocomplete"
             @focus="emit('focus')"
             @blur="emit('blur')"
             @input="handleInput"
             @change="emit('change', $event)"
             @keyup="emit('keyup', $event)"
             @keyup.enter="emit('enter')"
             :autofocus="autofocus"
             :readonly="readonly ? readonly : false"
             :value="value"/>
      <slot/>
      <a class="show-password"
         v-if="type === 'password'"
         @click="showPass = !showPass">
        <EyeSvg v-if="showPass"
                class="svg-light"/>
        <NoEyeSvg v-if="!showPass"
                  class="svg-light"/>
      </a>
    </div>
    <div v-if="!editMode" class="word-break">{{ value || '-' }}</div>
    <slot name="note"/>
    <ValidationError :class="{ 'mt-3': validationMargin }"
                     v-if="showErrors"
                     :validationId="validationId"/>
  </div>
</template>

<script setup>
import ValidationError from "@/components/form/ValidationError"
import EyeSvg from '@/assets/svg-vue/form/eye.svg'
import NoEyeSvg from '@/assets/svg-vue/form/noeye.svg'
import {ref} from "vue"

const props = defineProps({
  label: {},
  autocomplete: {
    type: String,
    default: 'on'
  },
  showErrors: {
    type: Boolean,
    default: false
  },
  validationId: {},
  value: {},
  type: {},
  readonly: {},
  placeholder: String,
  required: {
    type: Boolean,
    default: false
  },
  validationMargin: {
    type: Boolean,
    default: true
  },
  renderResult: {
    type: Function,
    required: false
  },
  autofocus: {
    type: Boolean,
    default: false
  },
  formLabelClass: {
    type: String,
  },
  inputRowClass: {},
  editMode: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['input', 'focus', 'change', 'keyup', 'enter', 'blur'])

// const content = ref(props.value)
const showPass = ref(false)
const input = ref(null)

const handleInput = (e) => {
  let res = e.target.value
  if(props.renderResult) {
    res = props.renderResult(res, props.validationId)
  }
  emit('input', res)
}

const focus = () => {
  input?.value.focus()
}

defineExpose({
  focus
})
</script>
